/**
 * MemberJunction Explorer - Application Component
 *
 * MJ 3.0 Minimal App Shell Pattern:
 * Reduced from 158 lines to 12 lines by using @memberjunction/ng-explorer-app
 */

import { Component } from '@angular/core';
import { MJNotificationService } from '@memberjunction/ng-notifications';

@Component({
  standalone: false,
  selector: 'app-root',
  template: '<mj-explorer-app />'
})
export class AppComponent {
  /**
   * Force-instantiate MJNotificationService at app bootstrap.
   *
   * MJNotificationService is a lazy `providedIn:'root'` singleton whose
   * `MJNotificationService.Instance` is only set once Angular first instantiates
   * it (via its constructor, which registers into the MJGlobal object store).
   * Every component that injects it lives in the shell, which renders AFTER
   * `mj-explorer-app`'s `handleLogin()`. That handler does
   * `MJNotificationService.Instance.ShouldSuppressToast = ...` — so for sessions
   * where the shell hasn't instantiated it yet (notably magic-link sessions),
   * `.Instance` is `undefined` and login throws
   * "Cannot set properties of undefined (setting 'ShouldSuppressToast')",
   * aborting routing to the app surface. Injecting it here makes Angular create
   * it at bootstrap, before login, so `.Instance` is always set.
   */
  constructor(_notifications: MJNotificationService) {}
}
